// Translations
import phoneVerificationDialog from '../components/phone-verification-dialog/translations/de'

// Translation: Model > Phone number verifier (German)
export default Object.freeze({
	actions: {
		verify: ''
	},
	components: { phoneVerificationDialog }
})
